import { UntypedFormControl } from "@angular/forms";

export function greaterThanZero(control: UntypedFormControl) { 
    const num = control.value; 
    if(num <= 0){
       return {error: "Value must be greater than 0"};
    }
    return null;
  }